/**
 * Routes list
 * Analytics labels API
 */
let _prefix = '/disk/v1'

export default {
  volume: _prefix + '/volume/',
  shared: _prefix + '/shared/',
  trash: _prefix + '/trash/',
  trashContent: _prefix + '/trash/',
  directory: _prefix + '/directory/',
  file: _prefix + '/file/',
  fileContent: _prefix + '/file/{id}/content/',
  transfer: _prefix + '/{type}/{id}/owner-request/',
  deleteTransfer: _prefix + '/owner-request/',
  permissions: _prefix + '/{type}/{id}/permission/',
  updatePermission: _prefix + '/permission/',
  deletePermission: _prefix + '/permission/',
  recover: _prefix + '/{type}/{id}/recover/',
  typedlink: _prefix + '/{type}/{id}/link/',
  link: _prefix + '/link/',
  linkContent: _prefix + '/link/',
  contentByToken: _prefix + '/{type}/{id}/{token}/',
  getHistory: _prefix + '/file/{file_id}/history/',
  history: _prefix + '/history/',
  checkoutHistory: _prefix + '/history/{id}/checkout/'
}


// WEBPACK FOOTER //
// ./src/apps/disk/api/routes.js